import { render } from "./SncrCallback.vue?vue&type=template&id=fcd796f6&scoped=true"
import script from "./SncrCallback.vue?vue&type=script&lang=js"
export * from "./SncrCallback.vue?vue&type=script&lang=js"

import "./SncrCallback.vue?vue&type=style&index=0&id=fcd796f6&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcd796f6"]])

export default __exports__